import RecordSourceTreeItem from "./RecordSourceTreeItem";
import React from "react";
import PropTypes from "prop-types";

const RootTreeLayout = (props) => {
    const {
        targetRecordType,
        rootItem,
        isMagicRoot,
        onIncludeMagicRootFields,
        onExcludeMagicRootFields,
        onExpandAll,
        onCollapseAll,
        isKeyExpanded,
        onChildCollapseOrExpand,
    } = props;
    const gridRef = React.useRef();
    const [gridOffset, setGridOffset] = React.useState(110);
    React.useEffect(() => {
        // calculate the table offset
        setGridOffset(gridRef.current.offsetTop);
    });
    const [showNullValueFields, setShowNullValueFields] = React.useState(false);
    let rootFields;
    if (isMagicRoot) {
        rootFields = (
            <span className="magic-root-fields">
                <a
                    className="include-fields"
                    onClick={onIncludeMagicRootFields}
                    style={{cursor: "pointer"}}
                >
                    Include {targetRecordType} Fields
                </a>
                {" / "}
                <a
                    className="exclude-fields"
                    onClick={onExcludeMagicRootFields}
                    style={{cursor: "pointer"}}
                >
                    Exclude {targetRecordType} Fields
                </a>
            </span>
        );
    }


    return (
        <React.Fragment>
            <div className="row mapping-treegrid-header">
                <div className="col-md-6 col-lg-8">Target Entity</div>
                <div className="col-md-3 col-lg-2">Post-Mapped Value (if checked)</div>
                <div className="col-md-3 col-lg-2">Pre-Mapped Value</div>
            </div>
            <div className="row mapping-actions" >
                <div className="col-md-12">
                    <button
                        type="button"
                        className="btn btn-expand-all"
                        onClick={onExpandAll}
                    >
                        <span />
                    </button>
                    <button
                        type="button"
                        className="btn btn-collapse-all"
                        onClick={onCollapseAll}
                    >
                        <span />
                    </button>
                    <span>&nbsp;</span>
                    {rootFields}
                    {" "}
                    <span className="missing-fields">
                        <a
                            className="show-fields"
                            onClick={() => setShowNullValueFields(true)}
                            style={{cursor: "pointer"}}
                        >
                            Show Fields with No Data
                        </a>
                        {" / "}
                        <a
                            className="hide-fields"
                            onClick={() => setShowNullValueFields(false)}
                            style={{cursor: "pointer"}}
                        >
                            Hide Fields with No Data
                        </a>
                    </span>
                </div>
            </div>
            <div ref={gridRef} />
            <div className="row mapping-grid" style={{top: gridOffset}}>
                <RecordSourceTreeItem
                    isKeyExpanded={isKeyExpanded}
                    onChildCollapseOrExpand={onChildCollapseOrExpand}
                    expanded
                    item={rootItem}
                    filter={(item) =>
                        showNullValueFields ? true :
                        (item.old !== "" || item.value !== "") || (item.children && item.children.length > 0)
                    }
                />
            </div>

        </React.Fragment>
    );
};

RootTreeLayout.propTypes = {
    rootItem: PropTypes.object.isRequired,
    targetRecordType: PropTypes.string.isRequired,
    isMagicRoot: PropTypes.bool.isRequired,
    onIncludeMagicRootFields: PropTypes.func.isRequired,
    onExcludeMagicRootFields: PropTypes.func.isRequired,
    onExpandAll: PropTypes.func.isRequired,
    onCollapseAll: PropTypes.func.isRequired,
    isKeyExpanded: PropTypes.func.isRequired,
    onChildCollapseOrExpand: PropTypes.func.isRequired,
};

export default RootTreeLayout;



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcetreegrid/RootTreeLayout.js